angular.module('unica_media_upload.media_services')

.factory('MediaUploadListService', function ($http, getBaseApiURL) {

	var mediaListService = {};

	mediaListService.list = function (eventId, limit, offset, status) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-upload/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
				status: status
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.medias;
			}

		});

	};


	mediaListService.get = function (mediaId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-upload/detail/' + mediaId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};


	return mediaListService;
});